export default __webpack_public_path__ + "static/media/gallery_02.68e611ad.jpg";